import { ChangeOptionType } from 'app/area/import-sets-administration/list/types';
import { ComplexValue } from 'app/types-shared';
import { ValidationProps } from 'ui';
import { ImportSetsSearchModel } from './types-store';

export const ACTION = {
  CLEAR_LIST: 'IMPORT_SETS_ADMINISTRATION:CLEAR_LIST',

  REQUEST_LIST: 'IMPORT_SETS_ADMINISTRATION:REQUEST_LIST',
  RECEIVE_LIST: 'IMPORT_SETS_ADMINISTRATION:RECEIVE_LIST',
  FAIL_LIST: 'IMPORT_SETS_ADMINISTRATION:FAIL_LIST',

  REQUEST_DELETE_IMPORT_SET: 'IMPORT_SETS_ADMINISTRATION:REQUEST_DELETE_IMPORT_SET',
  RECEIVE_DELETE_IMPORT_SET: 'IMPORT_SETS_ADMINISTRATION:RECEIVE_DELETE_IMPORT_SET',
  FAIL_DELETE_IMPORT_SET: 'IMPORT_SETS_ADMINISTRATION:FAIL_DELETE_IMPORT_SET',

  CHANGE_ADD_IMPORT_SET_FIELDS_BY_KEY: 'IMPORT_SETS_ADMINISTRATION:CHANGE_ADD_IMPORT_SET_FIELDS_BY_KEY',
  UPDATE_ADD_IMPORT_SET_VALIDATION: 'IMPORT_SETS_ADMINISTRATION:UPDATE_ADD_IMPORT_SET_VALIDATION',
  UPDATE_ADD_IMPORT_SET_IS_DIRTY: 'IMPORT_SETS_ADMINISTRATION:UPDATE_ADD_IMPORT_SET_IS_DIRTY',
  UPDATE_ADD_IMPORT_SET_STATE: 'IMPORT_SETS_ADMINISTRATION:UPDATE_ADD_IMPORT_SET_STATE',
  CLEAR_ADD_IMPORT_SET: 'IMPORT_SETS_ADMINISTRATION:CLEAR_ADD_IMPORT_SET',
  RESET_ADD_IMPORT_SET_VALIDATION: 'IMPORT_SETS_ADMINISTRATION:RESET_ADD_IMPORT_SET_VALIDATION'
};

export class ClearList {
  public type: string = ACTION.CLEAR_LIST;
  constructor(public requestId: number) { }
}

export class RequestList {
  public type: string = ACTION.REQUEST_LIST;
  constructor(public requestId: number, public model: ImportSetsSearchModel, public clearResults: boolean) { }
}

export class ReceiveList {
  public type: string = ACTION.RECEIVE_LIST;
  constructor(public requestId: number, public list: ComplexValue<number>[], public numberOfResults: number) { }
}

export class FailList {
  public type: string = ACTION.FAIL_LIST;
  constructor(public requestId: number) { }
}

export class RequestDeleteImportSet {
  public type: string = ACTION.REQUEST_DELETE_IMPORT_SET;
  constructor(public id: number) { }
}

export class ReceiveDeleteImportSet {
  public type: string = ACTION.RECEIVE_DELETE_IMPORT_SET;
  constructor(public id: number) { }
}

export class FailDeleteImportSet {
  public type: string = ACTION.FAIL_DELETE_IMPORT_SET;
  constructor(public id: number) { }
}

export class AddImportSetFieldsByKey {
  public type: string = ACTION.CHANGE_ADD_IMPORT_SET_FIELDS_BY_KEY;
  constructor(public key: string, public value: any) {
  }
}

export class UpdateAddImportSetValidation {
  public type: string = ACTION.UPDATE_ADD_IMPORT_SET_VALIDATION;
  constructor(public validation: { [key: string]: ValidationProps }) {
  }
}

export class UpdateAddImportSetIsDirty {
  public type: string = ACTION.UPDATE_ADD_IMPORT_SET_IS_DIRTY;
  constructor(public isDirty: boolean) {
  }
}

export class UpdateAddImportSetState {
  public type: string = ACTION.UPDATE_ADD_IMPORT_SET_STATE;
  constructor(public state: ChangeOptionType) {
  }
}

export class ClearAddImportSet {
  public type: string = ACTION.CLEAR_ADD_IMPORT_SET;
}

export class ResetAddImportSetValidation {
  public type: string = ACTION.RESET_ADD_IMPORT_SET_VALIDATION;
  constructor(public key: string) {
  }
}
